import React, { useState, useEffect, useRef } from "react";
import { signOutSubmit } from "../../redux/features/auth/authService";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import ToggleIcon from '../../assets/images/icons/toggle_icon.png';
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import DefaultImage from '../../assets/images/icons/blank_profile_pic.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ProfileIcon from '../../assets/images/icons/profile_icon.png';
import LogoutIcont from '../../assets/images/icons/logout_icon.png';

const Header = ({ toggleSidebar }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { pathname } = location;
    const { roleName, details } = useSelector(selectUserDetails);
    const [isOpen, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const role = pathname.split('/')[1];
    const splitAfterRole = pathname.split(`/${role}/`)[1];
    const pathSegments = splitAfterRole ? splitAfterRole.split('/') : [];
    const displaySegments = pathSegments.filter(segment => isNaN(segment)).slice(0, -1);

    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 430);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        dispatch(signOutSubmit())
            .unwrap()
            .then(() => {
                navigate('/login');
            })
            .catch((error) => {
                console.error("Logout failed:", error);
            });
    };

    const createLinkPath = (index) => {
        const basePath = `/${role}/`;
        const dynamicPath = pathSegments.slice(0, index + 1).join('/');
        return `${basePath}${dynamicPath}`;
    };

    const getProfile = () => {
        if (roleName === 'admin') {
            navigate('/admin/profile');
        } 
        if (roleName === 'coordinator') {
            navigate('/coordinator/profile');
        } 
        if (roleName === 'finance_department') {
            navigate('/finance/profile');
        }
        if (roleName === 'chairman') {
            navigate('/chairman/profile');
        }
        if (roleName === 'certificate_department') {
            navigate('/certificate/profile');
        }
    };
    
    return (
        <header className={styles.header}>
            <div className={styles.leftSec}>
                <div className={styles.toggleHeader}>
                    <img
                        src={ToggleIcon}
                        className={styles.toggleBtn}
                        alt="toggle"
                        onClick={toggleSidebar}
                    />
                </div>
                <div>
                    {isMobileView ? (
                        <span className={styles.currentSegment}>
                            {displaySegments[displaySegments.length - 1]
                                ?.replace(/-/g, ' ')
                                ?.replace(/\b\w/g, char => char.toUpperCase())}
                        </span>
                    ) : (
                        displaySegments.map((segment, index) => (
                            <span key={index} className={styles.pathDivider}>
                                {index < displaySegments.length - 1 ? (
                                    <Link
                                        to={createLinkPath(index)}
                                        className={styles.previousSegment}
                                    >
                                        {segment
                                            .replace(/-/g, ' ')
                                            .replace(/\b\w/g, char => char.toUpperCase())}
                                    </Link>
                                ) : (
                                    <span className={styles.currentSegment}>
                                        {segment
                                            .replace(/-/g, ' ')
                                            .replace(/\b\w/g, char => char.toUpperCase())}
                                    </span>
                                )}
                                {index < displaySegments.length - 1 && ' > '}
                            </span>
                        ))
                    )}
                </div>
            </div>
            <div
                className={styles.profileSec}
                onClick={() => setOpen(!isOpen)}
                ref={dropdownRef}
            >
                <img
                    src={details?.image_url ? details?.image_url : DefaultImage}
                    className={styles.imageSec}
                />
                {!isMobileView ? (
                    <div className={styles.detailsSec}>
                        <p className={styles.profileName}>{details?.full_name}</p>
                        <p className={styles.profileRole}>{roleName}</p>
                    </div>
                ) : null}
                <FontAwesomeIcon icon={faAngleDown} color="#9FA6B2" />
                {isOpen ? (
                    <ul className={styles.dropdownMenu}>
                        {/* <li className={styles.dropdownItem} onClick={getProfile}>
                            <img src={ProfileIcon} width={24} /> My Profile
                        </li> */}
                        <li onClick={handleLogout} className={styles.dropdownItem}>
                            <img src={LogoutIcont} width={24} />
                            Logout
                        </li>
                    </ul>
                ) : null}
            </div>
        </header>
    );
};

export default Header;